var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUnhide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3644 5.71321C15.6432 2.7376 12.4369 0.892578 9.00005 0.892578C5.56318 0.892578 2.35693 2.7376 0.635675 5.71321C0.540061 5.88758 0.540061 6.10133 0.635675 6.27571C2.35693 9.25695 5.56318 11.1076 9.00005 11.1076C12.4369 11.1076 15.6432 9.25695 17.3644 6.27571C17.46 6.10133 17.46 5.88758 17.3644 5.71321ZM9.00005 9.51571C7.05942 9.51571 5.48443 7.94072 5.48443 6.00009C5.48443 4.05946 7.05942 2.48446 9.00005 2.48446C10.9407 2.48446 12.5157 4.05946 12.5157 6.00009C12.5157 7.94072 10.9407 9.51571 9.00005 9.51571Z",
    fill: "#787FA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8.39062C10.3203 8.39062 11.3906 7.32031 11.3906 6C11.3906 4.67969 10.3203 3.60938 9 3.60938C7.67969 3.60938 6.60938 4.67969 6.60938 6C6.60938 7.32031 7.67969 8.39062 9 8.39062Z",
    fill: "#787FA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnhide);
export default __webpack_public_path__ + "static/media/iconUnhide.06595c220693203f1c4b08739b304569.svg";
export { ForwardRef as ReactComponent };